import { twMerge } from 'tailwind-merge';

import { tw } from '~/utils';

type ButtonSize = 'lg' | 'md' | 'sm';
type ButtonVariant = 'default' | 'outline';

export type ButtonStyles = {
  [variant in ButtonVariant]: {
    [size in ButtonSize]: string;
  };
};

const buttonBase = tw(
  'hover:border-grey-950 gap-6 self-center rounded-full border bg-clip-border text-white transition-colors hover:bg-white'
);
const defaultBase = tw('border-grey-950 bg-grey-950 hover:text-grey-900 text-white');
const outlineBase = tw('border-grey-200 text-grey-900 bg-white');

const buttonLarge = tw('!text-button-l min-h-[53px] min-w-[250px] px-10 py-4');
const buttonMedium = tw('!text-button-m h-auto w-full min-w-[100px] px-6 py-3');
const buttonSmall = tw('!text-button-s h-auto w-full min-w-[80px] px-4 py-1');

export const buttonStyles = tw<ButtonStyles>({
  default: {
    lg: twMerge(buttonBase, defaultBase, buttonLarge),
    md: twMerge(buttonBase, defaultBase, buttonMedium),
    sm: twMerge(buttonBase, defaultBase, buttonSmall),
  },
  outline: {
    lg: twMerge(buttonBase, outlineBase, buttonLarge),
    md: twMerge(buttonBase, outlineBase, buttonMedium),
    sm: twMerge(buttonBase, outlineBase, buttonSmall),
  },
});
